import { render, staticRenderFns } from "./AxCardContent.vue?vue&type=template&id=ba5b91e6&scoped=true"
import script from "./AxCardContent.vue?vue&type=script&lang=ts"
export * from "./AxCardContent.vue?vue&type=script&lang=ts"
import style0 from "./AxCardContent.vue?vue&type=style&index=0&id=ba5b91e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5b91e6",
  null
  
)

export default component.exports